import React, { useContext } from 'react'
import { css } from '@emotion/react'
import { string, bool } from 'prop-types'

import InstallButton from '../InstallButton'
import { DraftModeContext } from '../../context/draftMode'

const btnCss = (type) => (theme) =>
  css`
    flex-shrink: 0;

    ${type === 'link' &&
    `
    border: 0;
    background: transparent;
    padding: 0;
    font-weight: 400;
    color: ${theme.colors.black};
    font-size: 18px;

    &:hover {
      border: 0;
      background: transparent;
    }
  `}
  `

const ActionButton = ({
  id,
  size = 'large',
  fullWidth = true,
  type,
  className,
  useActionQuery,
  minimalisticLoader,
  onlyPrimaryButton,
}) => {
  const { draftMode } = useContext(DraftModeContext)

  return (
    <InstallButton
      css={btnCss(type)}
      appId={id}
      className={`${className ? className : ''} install`}
      size={size}
      draftMode={draftMode}
      fullWidth={fullWidth}
      useActionQuery={useActionQuery}
      minimalisticLoader={minimalisticLoader}
      onlyPrimaryButton={onlyPrimaryButton}
    />
  )
}

ActionButton.propTypes = {
  id: string.isRequired,
  size: string,
  fullWidth: bool,
  useActionQuery: bool,
  className: string,
  type: string,
  minimalisticLoader: bool,
  onlyPrimaryButton: bool,
}

export default ActionButton
